import { render } from "./AppHealth.vue?vue&type=template&id=41d6ddb8"
import script from "./AppHealth.vue?vue&type=script&lang=js"
export * from "./AppHealth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__